/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OfferDataFragment = {
  readonly __typename: 'Challenge';
  readonly achieved: number;
  readonly celebrationCopy: string;
  readonly descriptiveTitle: string;
  readonly expirationDate: string | null;
  readonly goal: number;
  readonly id: string;
  readonly legalTerms: string;
  readonly percentageCompleted: number;
  readonly permalink: string;
  readonly progressType: Types.ChallengeProgressType;
  readonly progress: number;
  readonly progressCopy: string;
  readonly status: Types.ChallengeStatus;
  readonly title: string;
  readonly theme: Types.ChallengeTheme;
  readonly assetUrl: string | null;
};

export type LoyaltyOffersQueryVariables = Types.Exact<{ [key: string]: never }>;

export type LoyaltyOffersQuery = {
  readonly __typename?: 'Query';
  readonly challenges: ReadonlyArray<{
    readonly __typename: 'Challenge';
    readonly themeV2: Types.ChallengeThemeV2;
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: string | null;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progressType: Types.ChallengeProgressType;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
    readonly theme: Types.ChallengeTheme;
    readonly assetUrl: string | null;
    readonly multipleBehaviorDetails: {
      readonly __typename?: 'HurdleBehaviorDetails';
      readonly hurdleBehaviors: ReadonlyArray<{
        readonly __typename?: 'HurdleBehavior';
        readonly goal: number;
        readonly progress: number;
        readonly achieved: number;
        readonly outcome: number;
      }>;
    } | null;
  }>;
};

export type LoyaltyOfferOptInMutationVariables = Types.Exact<{
  challengeId: Types.Scalars['String']['input'];
}>;

export type LoyaltyOfferOptInMutation = {
  readonly __typename?: 'Mutation';
  readonly challengeOptInV2:
    | {
        readonly __typename: 'Challenge';
        readonly themeV2: Types.ChallengeThemeV2;
        readonly achieved: number;
        readonly celebrationCopy: string;
        readonly descriptiveTitle: string;
        readonly expirationDate: string | null;
        readonly goal: number;
        readonly id: string;
        readonly legalTerms: string;
        readonly percentageCompleted: number;
        readonly permalink: string;
        readonly progressType: Types.ChallengeProgressType;
        readonly progress: number;
        readonly progressCopy: string;
        readonly status: Types.ChallengeStatus;
        readonly title: string;
        readonly theme: Types.ChallengeTheme;
        readonly assetUrl: string | null;
        readonly multipleBehaviorDetails: {
          readonly __typename?: 'HurdleBehaviorDetails';
          readonly hurdleBehaviors: ReadonlyArray<{
            readonly __typename?: 'HurdleBehavior';
            readonly goal: number;
            readonly progress: number;
            readonly achieved: number;
            readonly outcome: number;
          }>;
        } | null;
      }
    | {
        readonly __typename: 'LoyaltyOptInFailed';
        readonly errorMessage: string;
      };
};

export const OfferDataFragmentDoc = gql`
  fragment OfferData on Challenge {
    __typename
    achieved
    celebrationCopy
    descriptiveTitle
    expirationDate
    goal
    id
    legalTerms
    percentageCompleted
    permalink
    progressType
    progress
    progressCopy
    status
    title
    theme
    assetUrl
  }
`;
export const LoyaltyOffersDocument = gql`
  query LoyaltyOffers {
    challenges {
      ...OfferData
      themeV2
      multipleBehaviorDetails {
        ... on HurdleBehaviorDetails {
          hurdleBehaviors {
            goal
            progress
            achieved
            outcome
          }
        }
      }
    }
  }
  ${OfferDataFragmentDoc}
`;

export function useLoyaltyOffersQuery(
  options?: Omit<Urql.UseQueryArgs<LoyaltyOffersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyOffersQuery, LoyaltyOffersQueryVariables>({
    query: LoyaltyOffersDocument,
    ...options,
  });
}
export const LoyaltyOfferOptInDocument = gql`
  mutation loyaltyOfferOptIn($challengeId: String!) {
    challengeOptInV2(challengeId: $challengeId) {
      __typename
      ... on Challenge {
        ...OfferData
        themeV2
        multipleBehaviorDetails {
          ... on HurdleBehaviorDetails {
            hurdleBehaviors {
              goal
              progress
              achieved
              outcome
            }
          }
        }
      }
      ... on LoyaltyOptInFailed {
        errorMessage
        __typename
      }
    }
  }
  ${OfferDataFragmentDoc}
`;

export function useLoyaltyOfferOptInMutation() {
  return Urql.useMutation<
    LoyaltyOfferOptInMutation,
    LoyaltyOfferOptInMutationVariables
  >(LoyaltyOfferOptInDocument);
}
